import { ActionButton } from 'components'
import React from 'react'
import { Treaty_treaty } from '_graphql/queries/__generated__/Treaty'
import moment from 'moment'
import { useAppNavigate } from '_graphql/cache/auth'

type Props = {
    treaty: Treaty_treaty | null | undefined

}

const PortfolioStatment = ({ treaty }: Props) => {
    const navigate = useAppNavigate()
    return (
        <div className="bg-card-500 rounded-xl shadow-lg overflow-hidden">
            <div className="px-6 py-5 border-b border-gray-700/50">
                <h3 className="text-xl font-semibold text-primary">Portfolio Statement</h3>
                <p className="mt-1 text-sm text-tertiary">
                    This section provides the portfolio statement for the treaty, including the overall gross premium and the date of creation.
                </p>
            </div>
            <div className="p-6">
                <div className='bg-teal-200/20 rounded-lg p-4 mb-4 w-auto'>
                    <p className='text-sm text-teal-200'>
                        Found Portfolio statement for {moment(treaty?.treaty_proportional_detail?.created_at).format("LL")} below
                    </p>
                </div>
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-700/50">
                        <thead>
                            <tr>
                                <th className="px-4 py-3 text-left text-sm font-medium text-gray-300">Date</th>
                                <th className="px-4 py-3 text-left text-sm font-medium text-gray-300">Overall Gross Premium	</th>
                                <th className="px-4 py-3 text-left text-sm font-medium text-gray-300">Action</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-700/50">
                            <tr className="hover:bg-gray-700/30 transition-colors">
                                <td className="px-4 py-3 text-sm text-gray-100">{moment(treaty?.treaty_proportional_detail?.created_at).format("LL")}</td>
                                <td className="px-4 py-3 text-sm text-gray-100">{treaty?.treaty_proportional_detail?.overall_gross_premium || "N/A"}</td>
                                <td className="px-4 py-3 text-sm text-gray-100">
                                    <ActionButton
                                        action='update'
                                        onClick={() => navigate({
                                            search(prev) {
                                                return {
                                                    ...prev,
                                                    modal: 'portfolio-statement',
                                                }
                                            },
                                        })}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default PortfolioStatment